import React from 'react';

import classes from './FooterCopyright.module.css';

const footerCopyright = (props) => {
    let year = new Date();
    year = year.getFullYear();
    return (
        <div className={classes.Copyright}>
            <span>©<span>{year}</span>FabLab Nola</span>
        </div>
    );
}

export default footerCopyright;